import React,  { Component } from "react"
import './index.scss'
import { Modal } from 'antd'

import playIcon from '@/images/newHome/play.svg'
import closeIcon from '@/images/newHome/close.svg'

class HtDialogVideo extends Component {

    state = {
        isPlay: false
    }

    playVideo = () => {
        this.refs.video && this.refs.video.play()
    }

    play = () => {
        this.setState({
            isPlay: true
        })
    }

    seeking = () => {
        this.setState({
            isPlay: true
        })
    }

    seeked = () => {
        console.log(3)
    }

    pause = () => {
        this.setState({
            isPlay: false
        })
    }

    close = (e) => {
        e.persist()
        e.stopPropagation()
        this.props.close && this.props.close()
    }

    render(){
        return (
            <Modal visible={this.props.show} footer={null} closable={false} destroyOnClose={true} maskClosable={true} wrapClassName="ht-dialog-video">
                <div className="close-box">
                    <img className="close-icon" src={closeIcon} onClick={this.close} />
                </div>
                <div className="video-box">
                    <video className="video" ref="video" src={this.props.src} controls onPlay={this.play}  onSeeking={this.seeking} onSeeked={this.seeked} onPause={this.pause} poster={this.props.poster}></video>
                    {
                        !this.state.isPlay && <img className="play-icon" src={playIcon} onClick={this.playVideo}/>
                    }
                </div>
            </Modal>
        )
    }
}

export default HtDialogVideo